import * as moment from 'moment';
export class Utility {
    public static formatDate(date) {
        return moment(date).format('MMM Do YYYY');
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/utils.ts